document.addEventListener('DOMContentLoaded', function() {
  // Hero banner animation
  const sliderLeft = document.querySelector('.hero-banner_slider-left');
  const sliderRight = document.querySelector('.hero-banner_slider-right');
  
  if (sliderLeft && sliderRight) {
    const sliderLeftItems = sliderLeft.querySelectorAll('.slider__item');
    const sliderRightItems = sliderRight.querySelectorAll('.slider__item');
  
    // Get the height of the last .slider__item for each slider
    const sliderLeftLastItemHeight = sliderLeftItems[sliderLeftItems.length - 1].offsetHeight - 60;
    const sliderRightLastItemHeight = sliderRightItems[sliderRightItems.length - 1].offsetHeight - 60;
  
    // Set last item height for both to be the same (highest)
    const sliderLastItemHeight = sliderLeftLastItemHeight >= sliderRightLastItemHeight ?  sliderLeftLastItemHeight : sliderRightLastItemHeight;
  
    // Set the height dynamically based on the last item
    function setHeight(slider, lastItemHeight) {
      slider.style.setProperty('--last-item-height', `${lastItemHeight}px`);
    }
  
    // Set the height for both sliders
    setHeight(sliderLeft, sliderLastItemHeight);
    setHeight(sliderRight, sliderLastItemHeight);

    window.addEventListener('resize', e => {
      setHeight(sliderLeft, sliderLastItemHeight);
      setHeight(sliderRight, sliderLastItemHeight);
    });
  
    // Function to slide up
    function slideUp(slider) {
      slider.style.animation = `slideUp 10s ease-in-out forwards`;
    }
  
    // Function to slide down
    function slideDown(slider) {
      slider.style.animation = `slideDown 10s ease-in-out forwards`;
    }
  
    // Function to start the animation loop
    function startAnimation() {
      // Slide both up simultaneously
      slideUp(sliderLeft);
      slideUp(sliderRight);
  
      // After the up animation, wait and then slide both down simultaneously
      setTimeout(() => {
        slideDown(sliderLeft);
        slideDown(sliderRight);
      }, 10000);
  
      // Repeat the whole process to create a loop
      setTimeout(startAnimation, 25000);
    }
  
    // Start the animation loop
    startAnimation();
  }

   // Activate flickity slider
  const pgSliders = document.querySelectorAll('.pg-slider');
  pgSliders.forEach(slider => {
    const hasPrevNext = slider.classList.contains('has-prev-next');
    const sliderOpt = {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: hasPrevNext,
      pageDots: false,
      groupCells: true
    }
    if (hasPrevNext) {
      sliderOpt.arrowShape = {
        x0: 30,
        x1: 60, y1: 25,
        x2: 65, y2: 15,
        x3: 50
      }
    }
    let pgFlkty = new Flickity(slider, sliderOpt); 
    let container = slider.parentElement;
    const sliderNav = slider.closest('.container').querySelector('.slider-navigation');
    if (sliderNav) {
      if (slider.classList.contains('outside-nav')) {
        container = slider.closest('.container');
      }
      sliderNavigation(container, pgFlkty);
    }
    window.addEventListener('resize', () => {
      pgFlkty.resize();
    });
  }); 
  

  // tabs animation
  const tabContainer = document.querySelectorAll('.tab-col__collections');
  tabContainer.forEach(container => {
    const tabs = container.querySelectorAll('.tab-link');
    const contents = container.querySelectorAll('.tab-content');
    const activeSlider = container.querySelector('.active-slider');
    const defaultTab = Array.from(tabs)[0].getAttribute('href');
    const video = container.querySelector('video');
  
    function activateTab(targetId) {
        tabs.forEach(tab => {
            tab.classList.remove('active');
        });
  
        contents.forEach(content => {
            content.classList.remove('active');
            if (video) {
              const parent = video.closest('.video-thumb');
              setTimeout(() => {
                parent.querySelector('img').style.display = 'block';
                parent.querySelector('.video-button').style.display = 'flex';
                parent.querySelector('.video-wrapper').setAttribute('hidden', true);
                video.pause();
                video.currentTime = 0; 
              }, 300);
            }
        });
  
        const targetTab = container.querySelector(targetId + '-link');
        const targetContent = container.querySelector(targetId);
  
        if (targetTab && targetContent) {
            targetTab.classList.add('active');
            targetContent.classList.add('active');
  
            // Update the slider position
            const tabRect = targetTab.getBoundingClientRect();
            activeSlider.style.width = tabRect.width + 'px';
            activeSlider.style.left = targetTab.offsetLeft + 'px';
        }
    }
  
    // Activate the default tab on page load
    activateTab(defaultTab);
  
    tabs.forEach(tab => {
        tab.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            activateTab(targetId);
        });
    });
  
    // Update tab based on hash change (e.g., when browser back/forward buttons are used)
    window.addEventListener('hashchange', function() {
        activateTab(window.location.hash);
    });
  });

  // slider reviews 
  const items = document.querySelectorAll('.pg-slider .grid__item');
  items.forEach((item) => {
    const ratingEl = item.querySelectorAll('.rivyo-product-rating');
    const productId = item.dataset.id;
    const handle = item.dataset.handle;
  
    // rivyo api
    fetch(`https://thimatic-apps.com/product_review/get_product_data.php?shop=pure-green-franchise.myshopify.com&product_handle=${handle}&product_id=${productId}`)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        let reviewStarsHtml = '';
        const reviewStar = `
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
          <path d="M3.40015 14.8634L4.62768 9.55667L0.510742 5.9874L5.94963 5.51528L8.06475 0.510742L10.1799 5.51528L15.6188 5.9874L11.5018 9.55667L12.7294 14.8634L8.06475 12.0495L3.40015 14.8634Z" fill="#FF9500"/>
          </svg>
        `;
        const averageStar = html.querySelector('.wc_average_review_stars').dataset.avg.split('.');
        const reviewCountText = html.querySelector('.wc_review_count_text').textContent.split(' ');
        const reviewCount = reviewCountText[2];
        for (let i = 0; i < averageStar[0]; i++) {
          reviewStarsHtml += reviewStar;
        }
        ratingEl.forEach(el => {
          el.querySelector('.review-stars').innerHTML = reviewStarsHtml;
          el.querySelector('.total-reviews-text').textContent = reviewCountText[2] + ' reviews';
        });
        // setTimeout(() => {
        //   flkty.resize();
        // }, 0)
      })
      .catch(error => console.log('error', error));
  });
  
  // collection slider product
  const nextBtn = document.querySelectorAll('.col-slider__next');
  const prevBtn = document.querySelectorAll('.col-slider__prev');
  const sliderInner = document.querySelector('.col-slider-product__slider-inner');
  let currentIndex = 0;
  const contents = document.querySelectorAll('.col-slider-product__slider-content');
  if (sliderInner) {
    draggable(sliderInner);
  }
  
  // Set initial inner height based on the first content
  // sliderInner.style.height = contents[currentIndex].offsetHeight + 'px';
  
  nextBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      switchContent('next', contents);
    });
  })
  
  prevBtn.forEach(btn => {
    btn.addEventListener('click', () => {
      switchContent('prev', contents);
    });
  });
  
  function draggable(slider) {
    let isDragging = false;
    let startX;
    let deltaX = 0; // Track the final drag distance
  
    // Function to start dragging
    const startDrag = (clientX) => {
      isDragging = true;
      startX = clientX;
      deltaX = 0; // Reset deltaX at the start of each drag
    };
  
    // Function to perform dragging
    const performDrag = (clientX) => {
      if (!isDragging) return;
      deltaX = clientX - startX;
      // slider.style.transform = `translateX(${deltaX}px)`;
    };
  
    // Function to stop dragging and switch content
    const stopDrag = () => {
      if (isDragging) {
        isDragging = false;
        slider.style.transform = ''; // Reset position after drag
  
        // Call switchContent based on the drag direction and a threshold
        if (deltaX > 50) {
          switchContent('prev', contents); // Dragged to the right
        } else if (deltaX < -50) {
          switchContent('next', contents); // Dragged to the left
        }
      }
    };
  
    // Desktop event listeners
    slider.addEventListener('mousedown', (e) => startDrag(e.clientX));
    slider.addEventListener('mousemove', (e) => performDrag(e.clientX));
    slider.addEventListener('mouseup', stopDrag);
    slider.addEventListener('mouseleave', stopDrag); // Handle case if mouse leaves the element
  
    // Mobile event listeners
    slider.addEventListener('touchstart', (e) => startDrag(e.touches[0].clientX));
    slider.addEventListener('touchmove', (e) => performDrag(e.touches[0].clientX));
    slider.addEventListener('touchend', stopDrag);
  }

  
  function switchContent(direction) {
    const currentContent = contents[currentIndex];
  
    // Remove active class from the current content (fade out)
    currentContent.classList.remove('active');
  
    // Update index based on direction
    if (direction === 'next') {
      currentIndex = (currentIndex + 1) % contents.length;
    } else if (direction === 'prev') {
      currentIndex = (currentIndex - 1 + contents.length) % contents.length;
    }
  
    const nextContent = contents[currentIndex];
  
    // Set the inner container's height to match the next content
    // const nextHeight = nextContent.offsetHeight;
    // sliderInner.style.height = nextHeight + 'px';
  
    // Add active class to the next content (fade in)
    nextContent.classList.add('active');
  }

  //video play button
  const videoPlay = document.querySelectorAll('.video-button');
  videoPlay.forEach(btn => {
    btn.addEventListener('click', e => {
      const target = e.currentTarget;
      const parent = target.closest('.video-thumb');
      const video = parent.querySelector('video');
      video.play();
      target.style.display = 'none';
      parent.querySelector('img').style.display = 'none';
      parent.querySelector('.video-wrapper').removeAttribute('hidden');
    });
  });

  // tabbed collections hover
  // item includes
  document.querySelectorAll('.tab-col__slider-item').forEach(el => {
    const prodId = el.dataset.id;
    const includesEl = document.getElementById(`includes-${prodId}`);
    let includesObj = [];
    if (includesEl && includesEl.textContent != '') {
      includesObj = JSON.parse(includesEl.textContent);
    }
    const incJuices = el.querySelector('.item-includes__juices .items-list');
    const incShots = el.querySelector('.item-includes__shots .items-list');

    if (includesObj.length > 0) {
      includesObj.forEach(inc => {
        const type = inc.type.includes('Shot') ? 'shot' : 'juice';
        if (type === 'juice') {
          incJuices.innerHTML += inc.title;
          incJuices.innerHTML += '<span> + </span>';
        } else {
          incShots.innerHTML += inc.title;
          incShots.innerHTML += '<span> + </span>';
        }
      });
      if (incJuices.innerHTML == '') incJuices.parentElement.style.display = 'none';
      if (incShots.innerHTML == '') incShots.parentElement.style.display = 'none';
    }
  });

  // Collection slider atc 
  document.querySelectorAll('.atc-wrapper .variant-selector select').forEach(el => {
    el.addEventListener('change', e => {
      const val = el.value;
      const parent = el.closest('.atc-wrapper');
      const formId = parent.querySelector('input[name="id"]');
      formId.value = val;
    });
  });
});

// flickity functions
function toggleSliderDots(sliderDots, index) {
  for (let i = 0; i < sliderDots.length; i++) {
    if (sliderDots[i].classList.contains('active')) {
      sliderDots[i].classList.remove('active');
    }
  }
  document.querySelector(`.slider-dot[data-index="${index}"]`).classList.add('active');
}
function sliderNavigation(container, flkty) {
  const slideLeft = container.querySelector('.slide-left');
  const slideRight = container.querySelector('.slide-right');
  const sliderDots = container.querySelectorAll('.slider-dot');

  if (flkty.slides.length > 1 ) {
    slideRight.disabled = false;
  } else {
    slideLeft.disabled = true;
    slideRight.disabled = true;
  }

  window.addEventListener('resize', () => {
    flkty.resize();
    if (flkty.slides.length > 1) {
      slideRight.disabled = false;
    } else {
      slideLeft.disabled = true;
      slideRight.disabled = true;
    }
  });

  slideLeft.addEventListener('click', function(e) {
    slideLeft.disabled = false;
    slideRight.disabled = false;
    const target = e.currentTarget;
    flkty.previous();
    if (sliderDots.length > 0) {
      toggleSliderDots(sliderDots, flkty.selectedIndex);
    }
  });

  slideRight.addEventListener('click', function(e) {
    slideLeft.disabled = false;
    slideRight.disabled = false;
    const target = e.currentTarget;
    flkty.next();
    if (sliderDots.length > 0) {
      toggleSliderDots(sliderDots, flkty.selectedIndex);
    }
  });

  flkty.on('scroll', function(progress) {
    if (container.classList.contains('slider-wrapper')) {
      const progressEl = container.querySelector('.slider-progress');
      const currentWidth = progress * 100;
      if (progressEl) {
        progressEl.style.width = currentWidth + '%';
      }
      if (currentWidth <= 0) {
        slideLeft.disabled = true;
      } else if (currentWidth >= 99) {
        slideRight.disabled = true;
      } else {
        slideLeft.disabled = false;
        slideRight.disabled = false;
      }
    }
    if (sliderDots.length > 0) {
      toggleSliderDots(sliderDots, flkty.selectedIndex);
    }
  });
}

// draggable text slider 
const textSliders = document.querySelectorAll("draggable-slider");

textSliders.forEach(slider => {

  let isDown = false;
  let startX;
  let scrollLeft;
  
  // Mouse events
  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => {
    isDown = false;
  });

  slider.addEventListener("mouseup", () => {
    isDown = false;
  });

  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });

  // Touch events
  slider.addEventListener("touchstart", (e) => {
    isDown = true;
    startX = e.touches[0].pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("touchend", () => {
    isDown = false;
  });

  slider.addEventListener("touchmove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.touches[0].pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
  
});